import { ModalBase } from "../../../components/Modals/ModalBase";
import '../../../styles/ModalFacturaEmitida.css'

import Printer from '../../../media/felsv/Printer.svg'
import Email from '../../../media/felsv/Email.svg'
import Download from '../../../media/felsv/Download.svg'
import Folder from '../../../media/felsv/Folder.svg'
import DownloadImage from '../../../media/felsv/DownloadImage.svg'
import DownloadJson from '../../../media/felsv/DownloadJson.svg'
import AnularIcon from '../../../media/felsv/DarkAnular.svg'
import { Tooltip } from "../../../components/Tooltip/Tooltip";

export default function ModalDTEEmitido({ title, onClickNuevo, onClickCerrar, onClickVerDetalle, verDetalle, onClickPrint, onClickEmail, qrImage, onClickDownloadPDF, onClickDownloadExcel, onClickDownloadImage, onClickAnular, onClickDownloadJson,  ticketHabilitado, onClickPrintTicket,  onClickDownloadPDFTicket, enContingencia, }: { title: string, onClickNuevo: () => void, onClickCerrar: () => void, onClickVerDetalle: () => void, verDetalle: boolean, onClickPrint: () => void, onClickEmail: () => void, qrImage: any, onClickDownloadPDF: () => void, onClickDownloadExcel: () => void, onClickDownloadImage: () => void, onClickAnular: () => void, onClickDownloadJson: () => void, ticketHabilitado?: boolean,  onClickPrintTicket?: () => void, onClickDownloadPDFTicket?: () => void, enContingencia?: boolean }) {
    return (
        <ModalBase>
            <div className="dte-modal-emitido">
                <div >
                    <h3 className={`card-title ${enContingencia ? 'modal-emitido-titulo-contingencia' : ''}`}>{title}</h3>
                </div>
                <div className="separador" />
                {enContingencia &&
                    <p className='modal-emitido-nota-contingencia'>
                        El comprobante ya se le puede entregar al cliente, pero todavía no se ha
                        transmitido a Hacienda porque su servicio no está disponible. Se transmitirá
                        automáticamente cuando se restablezca.
                    </p>
                }
                <div className="dte-modal-emitido-content">
                    <div className="dte-modal-qr">
                        {qrImage &&
                            <img alt="Código QR" src={qrImage} className='modal-emitido-img-qr'/>
                        }
                    </div>
                    <div className="dte-modal-buttons">
                        <button onClick={onClickPrint} className='modal-emitido-button-icon'>
                        <Tooltip content="Imprimir">
                            <img src={Printer} alt='Imprimir' />
                        </Tooltip>
                        </button>
                        <button onClick={onClickEmail} className='modal-emitido-button-icon'>
                        <Tooltip content="Enviar por correo electrónico">
                            <img src={Email} alt='correo electrónico' />
                        </Tooltip>
                        </button>
                        <button onClick={onClickDownloadPDF} className='modal-emitido-button-icon'>
                        <Tooltip content="Descargar PDF">
                            <img src={Download} alt='Download' />
                        </Tooltip>
                        </button>
                        <button onClick={onClickDownloadExcel} className='modal-emitido-button-icon'>
                        <Tooltip content="Descargar excel">
                            <img src={Folder} alt='Download folder' />
                        </Tooltip>
                        </button>
                        <button onClick={onClickDownloadImage} className='modal-emitido-button-icon'>
                        <Tooltip content="Descargar imagen">
                            <img src={DownloadImage} alt='Download 2' />
                        </Tooltip>
                        </button>
                        <button onClick={onClickDownloadJson} className='modal-emitido-button-icon'>
                        <Tooltip content="Descargar json">
                            <img src={DownloadJson} alt='Download JSON' />
                        </Tooltip>
                        </button>
                        <button onClick={onClickAnular} className='modal-emitido-button-icon'>
                        <Tooltip content="Anular">
                            <img src={AnularIcon} alt='Download 2' />
                        </Tooltip>
                        </button>
                    </div>
                    {ticketHabilitado && (
  <>
    <div className="separador" />
    <label style={{ textAlign: 'center' }}>Opciones Ticket:</label>
    <div className="dte-modal-buttons">
      <button onClick={onClickPrintTicket} className='modal-emitido-button-icon'>
        <Tooltip content="Imprimir ticket">
          <img src={Printer} alt='Imprimir ticket' />
        </Tooltip>
      </button>
      <button onClick={onClickDownloadPDFTicket} className='modal-emitido-button-icon'>
        <Tooltip content="Descargar PDF Ticket">
          <img src={Download} alt='Descargar ticket' />
        </Tooltip>
      </button>
    </div>
  </>
)}

                    {verDetalle &&
                    <button onClick={onClickVerDetalle} className="button transparent w-inline-block"> Ver detalle completo </button>
                    }
                    <div className="separador"/>
                    <div className="dte-footer">
                        <button onClick={onClickCerrar} className="button transparent w-inline-block">Cerrar</button>
                    {verDetalle &&
                        <button onClick={onClickNuevo} className="button w-inline-block">Nuevo comprobante</button>
                    }
                    </div>
                </div>
            </div>
        </ModalBase>
    )
}